import {
  UPDATE_LANGUAGES, UPDATE_LANGUAGE, UPDATE_TOGGLE_MENU
} from '../constants';

const  initialState = {
  languages: null,
  lang: 'en',
  menu: false
};

export default function common(state = initialState, action) {
  switch (action.type) {
    case UPDATE_LANGUAGES:
      return {
        ...state,
        languages: action.languages
      };
    case UPDATE_LANGUAGE:
      return {
        ...state,
        lang: action.lang
      };
    case UPDATE_TOGGLE_MENU:
      return {
        ...state,
        menu: action.menu
      };
    default:
      return state;
  }
}
